export const api = process.env.REACT_APP_API;
export const tokenUrl = process.env.REACT_APP_TOKEN_NAME;
